import type { Controller } from "../lifecycle";

interface HtmxRequestEvent extends Event {
  detail?: { elt?: HTMLElement };
}

export class InquiryController implements Controller {
  private form?: HTMLFormElement;
  private button?: HTMLButtonElement;
  private defaultLabel?: HTMLElement;
  private loadingLabel?: HTMLElement;

  private readonly beforeRequest = (event: Event): void => {
    if ((event as HtmxRequestEvent).detail?.elt !== this.form) return;
    this.setLoading(true);
  };

  private readonly afterRequest = (event: Event): void => {
    if ((event as HtmxRequestEvent).detail?.elt !== this.form) return;
    this.setLoading(false);
  };

  mount(root: ParentNode): void {
    this.form =
      root.querySelector<HTMLFormElement>("[data-inquiry-form]") ?? undefined;
    this.button =
      this.form?.querySelector<HTMLButtonElement>("[data-inquiry-submit]") ??
      undefined;
    this.defaultLabel =
      this.form?.querySelector<HTMLElement>("[data-default-label]") ?? undefined;
    this.loadingLabel =
      this.form?.querySelector<HTMLElement>("[data-loading-label]") ?? undefined;

    document.body.addEventListener("htmx:beforeRequest", this.beforeRequest);
    document.body.addEventListener("htmx:afterRequest", this.afterRequest);
  }

  private setLoading(loading: boolean): void {
    if (!this.button) return;
    this.button.disabled = loading;
    this.button.dataset.state = loading ? "loading" : "default";
    if (this.defaultLabel) this.defaultLabel.hidden = loading;
    if (this.loadingLabel) this.loadingLabel.hidden = !loading;
  }

  destroy(): void {
    document.body.removeEventListener("htmx:beforeRequest", this.beforeRequest);
    document.body.removeEventListener("htmx:afterRequest", this.afterRequest);
    this.form = undefined;
    this.button = undefined;
    this.defaultLabel = undefined;
    this.loadingLabel = undefined;
  }
}
